var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"app-breadcrumb",attrs:{"separator":"/"}},_vm._l((_vm.menuPathList),function(item){return _c('el-breadcrumb-item',{key:item.menuId},[_vm._v(" "+_vm._s(item.menuName)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }